import { Flex, Image, Text } from '@chakra-ui/react';
import { useEffect, useState, type ReactNode } from 'react';
import YaxleLogo from '../../assets/yaxleLogoBlue.png';

interface InventoryItemImageProps {
    src?: string | null;
    alt?: string | null;
    /** Extra row under the fallback caption (e.g. an upload affordance), kept
     * inside the centered cluster so the mark and text stay centered. */
    hint?: ReactNode;
}

/**
 * Product photo for an inventory card. A missing or failed URL shows the
 * Yaxle mark centered, with the alt text underneath when present.
 */
const InventoryItemImage = ({ src, alt, hint }: InventoryItemImageProps) => {
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        setFailed(false);
    }, [src]);

    const showFallback = !src || failed;
    const caption = alt?.trim() || null;

    if (showFallback) {
        return (
            <Flex
                direction="column"
                align="center"
                justify="center"
                gap={2}
                px={3}
                py={4}
                w="100%"
                h="100%"
            >
                <Image
                    src={YaxleLogo}
                    alt=""
                    boxSize="40px"
                    objectFit="contain"
                    flexShrink={0}
                />
                {caption && (
                    <Text
                        fontSize="xs"
                        color="fg.muted"
                        textAlign="center"
                        noOfLines={2}
                        lineHeight="1.3"
                    >
                        {caption}
                    </Text>
                )}
                {hint}
            </Flex>
        );
    }

    return (
        <Image
            src={src}
            alt={caption ?? ''}
            objectFit="cover"
            w="100%"
            h="100%"
            onError={() => setFailed(true)}
        />
    );
};

export default InventoryItemImage;
